var _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z",
    fill: "#498200"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_873_119",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_873_119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.77486 9.575L11.0124 5.3375C11.1124 5.2375 11.2311 5.1875 11.3686 5.1875C11.5061 5.1875 11.6249 5.2375 11.7249 5.3375C11.8249 5.4375 11.8749 5.55625 11.8749 5.69375C11.8749 5.83125 11.8249 5.95 11.7249 6.05L7.12486 10.65C7.02486 10.75 6.90819 10.8 6.77486 10.8C6.64153 10.8 6.52486 10.75 6.42486 10.65L4.27486 8.5C4.17486 8.4 4.12694 8.28125 4.13111 8.14375C4.13528 8.00625 4.18736 7.8875 4.28736 7.7875C4.38736 7.6875 4.50611 7.6375 4.64361 7.6375C4.78111 7.6375 4.89986 7.6875 4.99986 7.7875L6.77486 9.575Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.6aee2acca023568f574b07d38495c669.svg";
export { ForwardRef as ReactComponent };